﻿/**
 * This file has been adapted from https://files.swissquote.com/tracking/prod/resources.javascript/tracking.js.
 * It has been adapted to work as an ES module.
 * It requires some refactoring to be compliant with CWS's quality requirements.
 */

import {uuid} from './math.uuid';

const serverTracking = "corpws1.swissquote.com";
const ACMVisitor = {};

function setCookie(cookieName, cookieValue, daysExpirationNumber) {
  let dt = new Date();
  dt.setDate(dt.getDate() + daysExpirationNumber);
  document.cookie = cookieName + "=" + escape(cookieValue) +
    ((daysExpirationNumber == null) ? "" : "; expires=" + dt.toGMTString()) +
    ";domain=" + getCookieDomain() + "; path=/";
}

function getCookie(cookieName) {
  let result = "";
  if (document.cookie.length > 0) {
    let strStart = document.cookie.indexOf(cookieName + "=");
    if (strStart != -1) {
      strStart = strStart + cookieName.length + 1;
      let strEnd = document.cookie.indexOf(";", strStart);
      if (strEnd == -1) strEnd = document.cookie.length;
      result = unescape(document.cookie.substring(strStart, strEnd));
    }
  }
  return result;
}

function getQueryString(key) {
  let result = "";
  const arrQueryString = window.location.search.substring(1).split("&");
  for (let i = 0; i < arrQueryString.length; i++) {
    if (arrQueryString[i].split("=")[0].toLowerCase() == key.toLowerCase()) {
      result = arrQueryString[i].split("=")[1];
    }
  }
  return result;
}

export function getACMVisitor() {

  if (!ACMVisitor.sessionId) {

    if (getQueryString("partnerid")) {
      ACMVisitor.partnerId = getQueryString("partnerid");
    }
    if (getQueryString("category")) {
      ACMVisitor.category = getQueryString("category");
    }
    if (getQueryString("formName")) {
      ACMVisitor.formName = getQueryString("formName");
    }

    let strSessionId;

    if (getCookie("sessionId") != "") {
      strSessionId = getCookie("sessionId");
    } else {
      strSessionId = uuid(25, 35);
    }
    setCookie("sessionId", strSessionId, 1);

    var strTrackPageId = strSessionId + "*" + uuid(10, 10)

    ACMVisitor.sessionId = strSessionId;
    ACMVisitor.trackPageId = strTrackPageId;

    if (getCookie("cookieId") != "") {
      ACMVisitor.cookieId = getCookie("cookieId");
    }
  }

  return ACMVisitor;
}

function setTextboxes() {
  if (document.getElementById("txtTrackPageId") != null) {
    document.getElementById("txtTrackPageId").value = ACMVisitor.trackPageId;
  }
  if (document.getElementById("txtCookieId") != null) {
    document.getElementById("txtCookieId").value = ACMVisitor.cookieId;
  }
  if (document.getElementById("txtSessionId") != null) {
    document.getElementById("txtSessionId").value = ACMVisitor.sessionId;
  }
}

/**
 * Get the correct cookie domain for the tracking cookies (every subdomains of the current domain).
 * Examples:
 *  - en.swissquote.com => .swissquote.com
 *  - en.stg.swissquote.com => .stg.swissquote.com
 *  - en.local.swissquote.com => .local.swissquote.com
 */
function getCookieDomain() {
  return '.' + window.location.host.split('.').splice(1).join('.');
}

export function getTrackPagePixelUrl() {

  const visitor = getACMVisitor();

  const arrQueryStrings = new Array();
  arrQueryStrings["tp"] = visitor.trackPageId;
  arrQueryStrings["ss"] = visitor.sessionId;
  arrQueryStrings["ck"] = ""; //strCookieId;
  arrQueryStrings["rf"] = document.referrer;
  arrQueryStrings["qs"] = window.location.search;

  arrQueryStrings["gc"] = getQueryString("gclid");
  arrQueryStrings["so"] = getQueryString("utm_source");
  if (!arrQueryStrings["so"]) {
    arrQueryStrings["so"] = getQueryString("source");
  }
  arrQueryStrings["me"] = getQueryString("utm_medium");
  arrQueryStrings["te"] = getQueryString("utm_term");
  if (!arrQueryStrings["te"]) {
    arrQueryStrings["te"] = getQueryString("kw");
  }
  arrQueryStrings["co"] = getQueryString("utm_content");
  arrQueryStrings["ca"] = getQueryString("utm_campaign");

  let strKey;
  let strQuerystring = "";
  for (strKey in arrQueryStrings) {
    if (arrQueryStrings[strKey] != "") {
      if (strQuerystring != "") {
        strQuerystring += "&";
      }
      strQuerystring += strKey + "=" + escape(arrQueryStrings[strKey]);
    }
  }

  return location.protocol + "//" + serverTracking + "/SQB.Microsoft.Tracking/TrackPage.aspx?" + strQuerystring + "&" + Math.random();
}

export function getCookieIdPixelUrl() {

  let acmVisitor = getACMVisitor();

  if (!acmVisitor.cookieId) {
    return null;
  }

  const arrQueryStrings = new Array();
  arrQueryStrings["tp"] = acmVisitor.trackPageId;
  arrQueryStrings["ck"] = acmVisitor.cookieId;

  let strKey;
  let strQuerystring = "";
  for (strKey in arrQueryStrings) {
    if (arrQueryStrings[strKey] != "") {
      if (strQuerystring != "") {
        strQuerystring += "&"
      }
      ;
      strQuerystring += strKey + "=" + escape(arrQueryStrings[strKey]);
    }
  }

  return location.protocol + "//" + serverTracking + "/SQB.Microsoft.Tracking/TrackCookieId.aspx?" + strQuerystring + "&" + Math.random();
}

